import './CodeBlockComponent.scss'

import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'
import React from 'react'

export default ({
  node: {
    attrs: { language: defaultLanguage, caption: currentCaption },
  },
  updateAttributes,
  extension,
}) => (
  <NodeViewWrapper className="code-block">
    <div className="code-block-toolbar" contentEditable={false}>
      <select
        defaultValue={defaultLanguage}
        onChange={event => updateAttributes({ language: event.target.value })}
      >
        <option value="null">auto</option>
        <option disabled>—</option>
        {extension.options.lowlight.listLanguages().map((lang, index) => (
          <option key={index} value={lang}>
            {lang}
          </option>
        ))}
      </select>
      <input
        type="text"
        className="code-caption-input"
        placeholder="Légende (optionnelle)…"
        defaultValue={currentCaption || ''}
        onBlur={event => {
          const value = event.target.value.trim();
          updateAttributes({ caption: value === '' ? null : value });
        }}
      />
    </div>
    <pre>
      <NodeViewContent as="code" />
    </pre>
    {currentCaption && (
      <figcaption className="code-block-caption" contentEditable={false}>
        {currentCaption}
      </figcaption>
    )}
  </NodeViewWrapper>
)
